import { z } from "zod";

export const stripeSettingsSchema = z.object({
  stripeEnabled: z.boolean(),
  stripePublishableKey: z.string(),
});

export type StripeSettingsFormData = z.infer<typeof stripeSettingsSchema>;
